"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
var core_1 = require("@material-ui/core");
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b, _c;
    return (0, core_1.makeStyles)({
        container: __assign(__assign({}, material_kit_pro_react_1.container), { paddingBottom: '24px' }),
        coloredShadow: material_kit_pro_react_1.coloredShadow,
        centered: {
            display: 'flex',
            justifyContent: 'center'
        },
        header: {
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(2)
        },
        imageContainer: (_a = {
                overflow: 'hidden',
                maxHeight: 480
            },
            _a[theme.breakpoints.down('lg')] = {
                maxHeight: 450
            },
            _a[theme.breakpoints.down('md')] = {
                maxHeight: 400
            },
            _a[theme.breakpoints.down('xs')] = {
                maxHeight: 360
            },
            _a),
        cardContent: {
            minHeight: 85
        },
        slickButton: (_b = {
                position: 'absolute',
                zIndex: 2,
                top: '50%',
                transform: 'translateY(-50%)',
                width: '40px',
                height: '40px',
                borderRadius: '50%',
                background: 'rgb(255 255 255 / 80%)',
                minWidth: '40px',
                padding: 0,
                left: '10px'
            },
            _b[theme.breakpoints.down('xs')] = {
                left: '8px'
            },
            _b),
        slickButtonNext: (_c = {
                left: 'unset',
                right: '10px'
            },
            _c[theme.breakpoints.down('xs')] = {
                right: '8px'
            },
            _c),
        carouselContainer: {
            '& .slick-dots': {
                position: 'absolute',
                left: '50%',
                transform: 'translateX(-50%)',
                width: 'unset',
                height: '25px',
                padding: '0px 16px 30px 16px',
                borderRadius: '5px',
                background: 'rgba(255, 255, 255, 0.8)'
            },
            '& .slick-dots li button': {
                width: '10px',
                height: '10px',
                padding: 0
            },
            '& .slick-dots li button::before': {
                backgroundColor: theme.palette.primary.main
            },
            '& .slick-dots li button:focus::before': {
                border: '2px solid black'
            },
            '& .slick-dots li': {
                width: '10px',
                height: '10px',
                margin: '0 10px'
            }
        }
    });
};
exports.styles = styles;
//# sourceMappingURL=styles.js.map